<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script setup>

</script>


<style>
body {
  margin: 0;
  padding: 0;
  background-color: #000;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
</style>